import {
    BEAM_REGISTER_REPORT_REQUEST,
    BEAM_REGISTER_REPORT_SUCCESS,
    BEAM_REGISTER_REPORT_FAILURE
  } from "../types/beam-register-report-types.js";
  
  const initialState = {
    beamRegisterReports: {},
    loading: false,
    error: null,
  };
  
  const beamRegisterReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case BEAM_REGISTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case BEAM_REGISTER_REPORT_SUCCESS: {
        return {
          ...state,
          beamRegisterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case BEAM_REGISTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default beamRegisterReportReducer;
  